import React from 'react';
import '../template-file-css/document-file-template.css';

{/**/ }
export const GENERAL_MedicaidAssessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_MedicaidAssessment' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <h1> <center> Medicaid Assessment </center> </h1>
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Name</span></td>
                        <td className='w-250'><span className='eleHeader'>MID</span></td>
                        <td className='w-250'><span className='eleHeader'>DOB</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtName' name='txtName' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtMID' name='txtMID' className='add-only' /></td>
                        <td className='w-250'><input type='date' id='txtDOB' name='txtDOB' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Relevant Diagnosis(es) (optional)</span>
                    <textarea id='txtRelevantDiagnosis' name='txtRelevantDiagnosis' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Requires Treatment Service(s) for:</span>
                    <td className='small'> Select All that Apply </td>
                </p>
                <table>
                    <tr>

                        <td className='w-250'>
                            <input type='checkbox' id='cbIdd' name='cbIdd' className='add-only' value='I/DD' />
                            I/DD
                        </td>

                        <td className='w-250'>
                            <input type='checkbox' id='cbSmi' name='cbSmi' className='add-only' value='SMI' />
                            SMI
                        </td>

                        <td className='w-250 '>
                            <input type='checkbox' id='cbSud ' name='cbSud ' className='add-only' value='SUD ' />
                            SUD
                        </td>

                    </tr>
                    <tr>

                        <td className='w-250'>
                            <input type='checkbox' id='cbTbi' name='cbTbi' className='add-only' value='TBI' />
                            TBI
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSed' name='cbSed' className='add-only' value='SED' />
                            SED
                        </td>

                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Care Manager/ Agency </span>
                    <textarea id='txtCareManager' name='txtCareManager' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Tailored Plan/ LME-MCO  </span>
                    <textarea id='txtTailoredPlan' name='txtTailoredPlan' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    Beneficiary reports/assessor has identified a need for services based on beneficiary having at least one functional deficit below:
                </p>
                <p className='w-750'>
                    <b>
                        Activities of Daily Living :
                    </b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Ambulation</span>
                    <input type='radio' id='rbAmbulation_None' name='rbAmbulation' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbAmbulation_Some' name='rbAmbulation' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbAmbulation_Total' name='rbAmbulation' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtAmbulation' name='txtAmbulation' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Bathing</span>
                    <input type='radio' id='rbBathing_None' name='rbBathing' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbBathing_Some' name='rbBathing' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbBathing_Total' name='rbBathing' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtBathing' name='txtBathing' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Dressing</span>
                    <input type='radio' id='rbDressing_None' name='rbDressing' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbDressing_Some' name='rbDressing' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbDressing_Total' name='rbDressing' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtDressing' name='txtDressing' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Eating</span>
                    <input type='radio' id='rbEating_None' name='rbEating' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbEating_Some' name='rbEating' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbEating_Total' name='rbEating' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtEating ' name='txtEating ' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Grooming</span>
                    <input type='radio' id='rbGrooming_None' name='rbGrooming' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbGrooming_Some' name='rbGrooming' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbGrooming_Total' name='rbGrooming' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtGrooming' name='txtGrooming' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Toileting</span>
                    <input type='radio' id='rbToileting_None' name='rbToileting' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbToileting_Some' name='rbToileting' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbToileting_Total' name='rbToileting' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtToileting' name='txtToileting' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Transfer</span>

                    <ul>
                        <li>
                            To from bed :
                            &nbsp; &nbsp; &nbsp;
                            <input type='radio' id='rbTransferFromBed_None' name='rbTransferFromBed' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                            <input type='radio' id='rbTransferFromBed_Some' name='rbTransferFromBed' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                            <input type='radio' id='rbTransferFromBed_Total' name='rbTransferFromBed' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total
                        </li>
                    </ul>



                </p>
                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtTransferFromBed' name='txtTransferFromBed' className='add-only'></textarea>
                </p>

                <p className='w-750'>

                    <ul>
                        <li>

                            To from car :
                            &nbsp; &nbsp; &nbsp;
                            <input type='radio' id='rbTransferFromCar_None' name='rbTransferFromCar' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                            <input type='radio' id='rbTransferFromCar_Some' name='rbTransferFromCar' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                            <input type='radio' id='rbTransferFromCar_Total' name='rbTransferFromCar' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                        </li>
                    </ul>



                </p>
                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtTransferFromCar' name='txtTransferFromCar' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <b>
                        Instrumental Activities
                    </b>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Home Maintenance</span>
                    <input type='radio' id='rbHomeMaintenance_None' name='rbHomeMaintenance' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbHomeMaintenance_Some' name='rbHomeMaintenance' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbHomeMaintenance_Total' name='rbHomeMaintenance' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtHomeMaintenance' name='txtHomeMaintenance' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Housekeeping</span>
                    <input type='radio' id='rbHousekeeping_None' name='rbHousekeeping' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbHousekeeping_Some' name='rbHousekeeping' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbHousekeeping_Total' name='rbHousekeeping' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtHousekeeping' name='txtHousekeeping' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Laundry</span>
                    <input type='radio' id='rbLaundry_None' name='rbLaundry' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbLaundry_Some' name='rbLaundry' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbLaundry_Total' name='rbLaundry' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtLaundry' name='txtLaundry' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Meal Prep</span>
                    <input type='radio' id='rbMealPrep_None' name='rbMealPrep' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbMealPrep_Some' name='rbMealPrep' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbMealPrep_Total' name='rbMealPrep' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtMealPrep' name='txtMealPrep' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Money Management</span>
                    <input type='radio' id='rbMoneyManagement_None' name='rbMoneyManagement' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbMoneyManagement_Some' name='rbMoneyManagement' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbMoneyManagement_Total' name='rbMoneyManagement' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtMoneyManagement' name='txtMoneyManagement' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Shopping/errands</span>
                    <input type='radio' id='rbShoppingErrands_None' name='rbShoppingErrands' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbShoppingErrands_Some' name='rbShoppingErrands' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbShoppingErrands_Total' name='rbShoppingErrands' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtShoppingErrands' name='txtShoppingErrands' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Transportation</span>

                    <ul>
                        <li>
                            Use of :
                            &nbsp; &nbsp; &nbsp;
                            <input type='radio' id='rbTransportationUseOf_None' name='rbTransportationUseOf' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                            <input type='radio' id='rbTransportationUseOf_Some' name='rbTransportationUseOf' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                            <input type='radio' id='rbTransportationUseOf_Total' name='rbTransportationUseOf' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total
                        </li>
                    </ul>



                </p>
                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtUseOf' name='txtUseOf' className='add-only'></textarea>
                </p>

                <p className='w-750'>

                    <ul>
                        <li>

                            Scheduling :
                            &nbsp; &nbsp; &nbsp;
                            <input type='radio' id='rbTransportationScheduling_None' name='rbTransportationScheduling' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                            <input type='radio' id='rbTransportationScheduling_Some' name='rbTransportationScheduling' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                            <input type='radio' id='rbTransportationScheduling_Total' name='rbTransportationScheduling' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                        </li>
                    </ul>

                </p>
                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtScheduling' name='txtScheduling' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <b>
                        Social and Work
                    </b>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Interacting with others</span>
                    <input type='radio' id='rbInteractingWithOthers_None' name='rbInteractingWithOthers' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbInteractingWithOthers_Some' name='rbInteractingWithOthers' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbInteractingWithOthers_Total' name='rbInteractingWithOthers' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtInteractingWithOthers' name='txtInteractingWithOthers' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Responding to negative feedback</span>
                    <input type='radio' id='rbNegativeFeedback_None' name='rbNegativeFeedback' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbNegativeFeedback_Some' name='rbNegativeFeedback' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbNegativeFeedback_Total' name='rbNegativeFeedback' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtNegativeFeedback' name='txtNegativeFeedback' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Responding to change</span>
                    <input type='radio' id='rbRespondingToChange_None' name='rbRespondingToChange' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbRespondingToChange_Some' name='rbRespondingToChange' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbRespondingToChange_Total' name='rbRespondingToChange' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtRespondingToChange' name='txtRespondingToChange' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Screening out environmental stimuli</span>
                    <input type='radio' id='rbScreeningOutEnvironmental_None' name='rbScreeningOutEnvironmental' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbScreeningOutEnvironmental_Some' name='rbScreeningOutEnvironmental' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbScreeningOutEnvironmental_Total' name='rbScreeningOutEnvironmental' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtScreeningOutEnvironmental' name='txtScreeningOutEnvironmental' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Maintaining stamina</span>
                    <input type='radio' id='rbMaintainingStamina_None' name='rbMaintainingStamina' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbMaintainingStamina_Some' name='rbMaintainingStamina' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbMaintainingStamina_Total' name='rbMaintainingStamina' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtMaintainingStamina' name='txtMaintainingStamina' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Handling time pressures and multiple tasks</span>
                    <input type='radio' id='rbHandlingTime_None' name='rbHandlingTime' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbHandlingTime_Some' name='rbHandlingTime' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbHandlingTime_Total' name='rbHandlingTime' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtHandlingTime' name='txtHandlingTime' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Ability to learn new tasks</span>
                    <input type='radio' id='rbAbilityToLearn_None' name='rbAbilityToLearn' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbAbilityToLearn_Some' name='rbAbilityToLearn' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbAbilityToLearn_Total' name='rbAbilityToLearn' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtAbilityToLearn' name='txtAbilityToLearn' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Acceptable speed of completing tasks</span>
                    <input type='radio' id='rbAcceptableSpeed_None' name='rbAcceptableSpeed' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbAcceptableSpeed_Some' name='rbAcceptableSpeed' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbAcceptableSpeed_Total' name='rbAcceptableSpeed' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtAcceptableSpeed' name='txtAcceptableSpeed' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <b>
                        Cognitive/Behavior
                    </b>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Speech/ Language/ Communication</span>
                    <input type='radio' id='rbSpeechLanguageCommunication_None' name='rbSpeechLanguageCommunication' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbSpeechLanguageCommunication_Some' name='rbSpeechLanguageCommunication' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbSpeechLanguageCommunication_Total' name='rbSpeechLanguageCommunication' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtSpeechLanguageCommunication' name='txtSpeechLanguageCommunication' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Self-Direction</span>
                    <input type='radio' id='rbSelfDirection_None' name='rbSelfDirection' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbSelfDirection_Some' name='rbSelfDirection' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbSelfDirection_Total' name='rbSelfDirection' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtSelfDirection' name='txtSelfDirection' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Social Development</span>
                    <input type='radio' id='rbSocialDevelopment_None' name='rbSocialDevelopment' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbSocialDevelopment_Some' name='rbSocialDevelopment' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbSocialDevelopment_Total' name='rbSocialDevelopment' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtSocialDevelopment' name='txtSocialDevelopment' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Learning</span>
                    <input type='radio' id='rbLearning_None' name='rbLearning' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbLearning_Some' name='rbLearning' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbLearning_Total' name='rbLearning' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtLearning' name='txtLearning' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Vocational Development</span>
                    <input type='radio' id='rbVocationalDevelopment_None' name='rbVocationalDevelopment' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbVocationalDevelopment_Some' name='rbVocationalDevelopment' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbVocationalDevelopment_Total' name='rbVocationalDevelopment' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtVocationalDevelopment' name='txtVocationalDevelopment' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Maladaptive Behavior</span>
                    <input type='radio' id='rbMaladaptiveBehavior_None' name='rbMaladaptiveBehavior' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbMaladaptiveBehavior_Some' name='rbMaladaptiveBehavior' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbMaladaptiveBehavior_Total' name='rbMaladaptiveBehavior' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtMaladaptiveBehavior' name='txtMaladaptiveBehavior' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Psychosis/ Hallucinations</span>
                    <input type='radio' id='rbPsychosisHallucinations_None' name='rbPsychosisHallucinations' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbPsychosisHallucinations_Some' name='rbPsychosisHallucinations' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbPsychosisHallucinations_Total' name='rbPsychosisHallucinations' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtPsychosisHallucinations' name='txtPsychosisHallucinations' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Mild Memory Loss</span>
                    <input type='radio' id='rbAcceptableSpeed_None' name='rbAcceptableSpeed' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbAcceptableSpeed_Some' name='rbAcceptableSpeed' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbAcceptableSpeed_Total' name='rbAcceptableSpeed' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtAcceptableSpeed' name='txtAcceptableSpeed' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Moderate Memory Loss</span>
                    <input type='radio' id='rbModerateMemoryLoss_None' name='rbModerateMemoryLoss' className='add-only' value='AssistanceNeededNone' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbModerateMemoryLoss_Some' name='rbModerateMemoryLoss' className='add-only' value='AssistanceNeededSome' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbModerateMemoryLoss_Total' name='rbModerateMemoryLoss' className='add-only' value='AssistanceNeededTotal' /> Assistance Needed Total

                </p>


                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtModerateMemoryLoss' name='txtModerateMemoryLoss' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Other:</span>
                    <input type='text' id='txtOther' name='txtOther' className='add-only w-750 custom-add-only' />

                    <br />


                    <input type='radio' id='rbOther_None' name='rbOther' className='add-only' value='Other_None' /> Assistance Needed None &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbOther_Some' name='rbOther' className='add-only' value='Other_Some' /> Assistance Needed Some &nbsp; &nbsp; &nbsp;
                    <input type='radio' id='rbOther_Total' name='rbOther' className='add-only' value='Other_Total' /> Assistance Needed Total
                </p>
                <p className='w-750'>
                    Comment:
                    <span className='small'>(e.g., who assists, equipment used, problems or issues for caregivers, type of assistance needed)</span>
                    <textarea id='txtOtherComment' name='txtOtherComment' className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Does the individual require support to manage a medical or health condition? </span>
                    <input type='radio' id='rbHealthCondition_Yes' name='rbHealthCondition' className='add-only' value='Yes' /> Yes &nbsp; &nbsp;
                    <input type='radio' id='rbHealthCondition_No' name='rbHealthCondition' className='add-only' value='No' /> No

                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Comment</span>
                    <textarea name="txtComment_1" id="txtComment_1" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Does the individual need support to acquire or maintain employment? </span>
                    <input type='radio' id='rbMaintainEmployment_Yes' name='rbMaintainEmployment' className='add-only' value='Yes' /> Yes &nbsp; &nbsp;
                    <input type='radio' id='rbMaintainEmployment_No' name='rbMaintainEmployment' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Comment</span>
                    <textarea name="txtComment_2" id="txtComment_2" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Is the primary caregiver in need of respite?  </span>
                    <input type='radio' id='rbNeedRespite_Yes' name='rbNeedRespite' className='add-only' value='Yes' /> Yes &nbsp; &nbsp;
                    <input type='radio' id='rbNeedRespite_No' name='rbNeedRespite' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Comment</span>
                    <textarea name="txtComment_3" id="txtComment_3" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Is the individual in need of rehabilitative/habilitative service for ADLs/IADLs/Social Skills/Employment Skills/etc.?  </span>
                    <input type='radio' id='rbEmploymentSkills_Yes' name='rbEmploymentSkills' className='add-only' value='Yes' /> Yes &nbsp; &nbsp;
                    <input type='radio' id='rbEmploymentSkills_No' name='rbEmploymentSkills' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Comment</span>
                    <textarea name="txtComment_4" id="txtComment_4" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Current Living Arrangement (i.e., At home w/ Family, Group Home, ACH, etc.): </span>
                </p>

                <p className='w-750'>
                    <textarea name="txtComment_5" id="txtComment_5" className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Are there plans for the individual to move to an independent living arrangement within the next 60 days? </span>
                    <input type='radio' id='rbIndependentLivingArrangement_Yes' name='rbIndependentLivingArrangement' className='add-only' value='Yes' /> Yes &nbsp; &nbsp;
                    <input type='radio' id='rbIndependentLivingArrangement_No' name='rbIndependentLivingArrangement' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Comment</span>
                    <textarea name="txtComment_6" id="txtComment_6" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Beneficiary requests the following services (please check all that apply): </span>
                </p>

                <table>
                    <tr>

                        <td className='w-375'>
                            <input type='checkbox' id='cbBeneficiaryRequests_1' name='cbBeneficiaryRequests_1' className='add-only' value='Community Transition' /> Community Transition.
                        </td>

                        <td className='w-375'>  <input type='checkbox' id='cbBeneficiaryRequests_2' name='cbBeneficiaryRequests_2' className='add-only' value='Respite' /> Respite.
                        </td>

                    </tr>

                    <tr>

                        <td className='w-375'>
                            <input type='checkbox' id='cbBeneficiaryRequests_3' name='cbBeneficiaryRequests_3 ' className='add-only' value='Individual and Transitional Supports ' /> Individual and Transitional Supports.
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbBeneficiaryRequests_4' name='cbBeneficiaryRequests_4 ' className='add-only' value='Community Living Supports ' />  Community Living Supports.
                        </td>

                    </tr>

                    <tr>

                        <td className='w-375'>
                            <input type='checkbox' id='cbBeneficiaryRequests_5' name='cbBeneficiaryRequests_5' className='add-only' value='Supported Employment/Individual Placement Supports' /> Supported Employment/Individual Placement Supports.
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbBeneficiaryRequests_6' name='cbBeneficiaryRequests_6' className='add-only' value='Beneficiary does not meet Target Population for any of the above services' />  Beneficiary does not meet Target Population for any of the above services.
                        </td>

                    </tr>
                </table>

                <table>


                    <tr>
                        <td className='signature w-375'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Assessor </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-750'></td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Print Name of Assessor </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}